module.exports = __webpack_public_path__ + "img/landing-major.e80c236d.png";